export function getAppVersion() {
  return import.meta.env.VITE_UI_VERSION ?? import.meta.env.VITE_APP_VERSION;
}

(window as any).getAppVersion = getAppVersion;
